import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StorageConstants } from '../../../constant/storage.constant';
import { RoleCodeEnum } from '../../../enum/role-code.enum';
import { RouteEnum } from '../../../enum/route.enum';
import { AllowedStoreTypeEnum } from '../../../enum/type/allowed-store-type.enum';
import { CustomerSearchRequest } from '../../../models/rest/customer/customerSearchRequest';
import { CallerIdLogCreateResponseModel } from '../../../models/rest/voip/caller-id-log-create-response.model';
import { AuthService } from '../../../services/auth.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import { UserOperationalService } from '../../../services/user-operational.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderPickupAddComponent } from '../../../pages/order/order-pickup-add/order-pickup-add.component';
import { ModalSizeEnum } from '../../../enum/modal-size.enum';
import { AlertifyService } from '../../../services/core/alertify.service';

@Component({
  selector: 'app-incoming-call-display-modal',
  templateUrl: './incoming-call-display-modal.component.html',
  styleUrls: ['./incoming-call-display-modal.component.css']
})
export class IncomingCallDisplayModalComponent implements OnInit {
  @Input() data: CallerIdLogCreateResponseModel;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  roleCodeEnum = RoleCodeEnum;
  routeEnum = RouteEnum;
  constructor(
    private translate: TranslateService,
    private sessionStorageService: SessionStorageService,
    private router: Router,
    private authService: AuthService,
    private userOperationalService: UserOperationalService,
    private modalService: NgbModal,
    private alertifyService: AlertifyService
  ) { }

  get canDisplayPhoneUnmasked(): boolean {
    return this.userOperationalService.hasPermissionByRoleCode(RoleCodeEnum.DISPLAY_CUSTOMER_PHONE_NUMBER_UNMASK);
  }

  ngOnInit(): void {
  }

  //Yeni sipariş oluşturma ekranına geç
  goNewOrder(route: String) {

    // Yetki kontrolü
    if (!this.userOperationalService.checkAndOpenModalIfNecessary(RoleCodeEnum.ORDER_CREATE, this.authService.getStoreId(), AllowedStoreTypeEnum.ORDER))
      return;

    if (route === RouteEnum.ORDER_PICKUP_ADD) {
      // Modal olarak aç
      const modalRef = this.modalService.open(OrderPickupAddComponent, {
        backdrop: 'static',
        centered: true,
        scrollable: false,
        size: ModalSizeEnum.LARGE
      });

      modalRef.componentInstance.customerId = this.data.customerId;

      modalRef.componentInstance.passEntry.subscribe((result: any) => {
        // if (result?.saved) {
        //   this.alertifyService.success(
        //     this.translate.instant('order.orderCode') + ': ' + result.order.orderCode
        //   );
        // }
        modalRef.close();
        this.passEntry.emit();
      });
    } else {
      this.router.navigate([route], {
        queryParams: { customerId: this.data.customerId }, skipLocationChange: false
      });
      this.passEntry.emit();
    }
  }


  async goCustomerDetail() {
    // Yetki kontrolü
    if (! await this.userOperationalService.checkAndOpenModalIfNecessary(RoleCodeEnum.CUSTOMER_VIEW,
      this.authService.getStoreId(), AllowedStoreTypeEnum.CUSTOMER)) {
      return;
    }



    this.router.navigate([`${RouteEnum.CUSTOMER_DETAIL}/${this.data.customerId}`], { skipLocationChange: false });
    this.passEntry.emit();
  }


  goNewCustomer() {

    let customerSearchRequest = new CustomerSearchRequest();
    customerSearchRequest.phone = this.data.incomingNo;
    this.sessionStorageService.setJSONData(StorageConstants.SEARCH_CRITERIA, customerSearchRequest);
    this.router.navigate([RouteEnum.CUSTOMER_ADD], { skipLocationChange: false });
    this.passEntry.emit();
  }

  close() {
    this.passEntry.emit();
  }
}
